import React from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { useInvoicesView } from "contexts/InvoicesViewContext";

interface Props {
    onClearFilters: () => void;
    onCreateBlankTemplate?: () => void;
}

function hasPickerUserFilters(
    filters: ReturnType<typeof useInvoicesView>["filters"],
): boolean {
    return (
        !!filters?.search?.trim() ||
        !!filters?.entityIds?.length ||
        !!filters?.counterpartiesIds?.length ||
        !!filters?.invoiceStatuses?.length ||
        filters?.minAmount != null ||
        filters?.maxAmount != null ||
        filters?.overdue != null
    );
}

export const InvoicesDrillDownPickerEmptyView: React.FC<Props> = ({
    onClearFilters,
    onCreateBlankTemplate,
}) => {
    const { filters } = useInvoicesView();

    if (hasPickerUserFilters(filters)) {
        return (
            <EmptyState
                header="The filters don't match any invoices."
                action={onClearFilters}
            />
        );
    }

    return (
        <EmptyState
            header="No Kick invoices yet."
            body="Create a Kick invoice first, or start a blank template."
            ctaText="Create blank template"
            action={onCreateBlankTemplate}
        />
    );
};
